/**
 * Get reset state mutation
 * @param stateConstructor
 */
function getResetStateMutation(stateConstructor) {
  return state => {
    Object.assign(state, stateConstructor());
  };
}

export { getResetStateMutation };
